/**
 * Chat bubble used inside MayaProfileChat. Two visual states:
 *   • from="ava"  — left-aligned white bubble with a purple "Maya" header
 *   • from="user" — right-aligned purple bubble
 */
import React from 'react';

export const Bubble = ({ from, children, avaName }) => (
  <div
    className={`flex ${from === 'ava' ? 'justify-start' : 'justify-end'} mb-3`}
    data-testid={`maya-bubble-${from}`}
  >
    <div
      className={`max-w-md rounded-2xl px-4 py-3 text-sm leading-relaxed shadow-sm ${
        from === 'ava'
          ? 'bg-white text-gray-800 border border-gray-200'
          : 'bg-purple-600 text-white'
      }`}
    >
      {from === 'ava' && avaName && (
        <p className="text-xs font-semibold text-purple-700 mb-1">{avaName}</p>
      )}
      {children}
    </div>
  </div>
);
